module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_1000_5000.7534ec89.png";